import * as DrugsType from "../../action/actiontype/Drugs/DrugsType";

const drugsReducer = (state = {}, action) => {
    switch (action.type) {
        // Drugs get all

        case DrugsType.DRUGS_LIST_REQUEST:
            return {
                ...state,
                drugsGetAllIdLoading: true,
                drugsGetAllIdResponse: [],
                drugsGetAllIdError: null,
            }
        case DrugsType.DRUGS_LIST_SUCCESS:
            return {
                ...state,
                drugsGetAllIdLoading: false,
                drugsGetAllIdResponse: action.payload,
                drugsGetAllIdError: null,
            }
        case DrugsType.DRUGS_LIST_FAILURE:
            return {
                ...state,
                drugsGetAllIdLoading: false,
                drugsGetAllIdResponse: {},
                drugsGetAllIdError: action.payload,
            }
        // Drugs add

        case DrugsType.DRUGS_ADD_REQUEST:
            return {
                ...state,
                drugsAddLoading: true,
                drugsAddResponse: [],
                drugsAddeError: null,
            }
        case DrugsType.DRUGS_ADD_SUCCESS:
            return {
                ...state,
                drugsAddLoading: true,
                drugsAddResponse: action.payload,
                drugsAddeError: null,
            }
        case DrugsType.DRUGS_ADD_FAILURE:
            return {
                ...state,
                drugsAddLoading: false,
                drugsAddResponse: {},
                drugsAddeError: action.payload,
            }
        // Product type dropdown api

        case DrugsType.PRODUCT_TYPE_DROPDOWN_REQUEST:
            return {
                ...state,
                productTypeDropdownLoading: true,
                productTypeDropdownResponse: [],
                productTypeDropdownError: null,
            }
        case DrugsType.PRODUCT_TYPE_DROPDOWN_SUCCESS:
            return {
                ...state,
                productTypeDropdownLoading: false,
                productTypeDropdownResponse: action.payload,
                productTypeDropdownError: null,
            }
        case DrugsType.PRODUCT_TYPE_DROPDOWN_FAILURE:
            return {
                ...state,
                productTypeDropdownLoading: false,
                productTypeDropdownResponse: {},
                productTypeDropdownError: action.payload,
            }

        // Class dropdown api
        case DrugsType.CLASS_DROPDOWN_REQUEST:
            return {
                ...state,
                classDropdownGetLoading: true,
                classDropdownGetResponse: [],
                classDropdownGetError: null,
            }
        case DrugsType.CLASS_DROPDOWN_SUCCESS:
            return {
                ...state,
                classDropdownGetLoading: false,
                classDropdownGetResponse: action.payload,
                classDropdownGetError: null,
            }
        case DrugsType.CLASS_DROPDOWN_FAILURE:
            return {
                ...state,
                classDropdownGetLoading: false,
                classDropdownGetResponse: [],
                classDropdownGetError: action.payload,
            }

        // recipe type dropdown api

        case DrugsType.RECIPE_TYPE_DROPDOWN_REQUEST:
            return {
                ...state,
                recipeTypeDropdownGetLoading: true,
                recipeTypeDropdownGetResponse: [],
                recipeTypeDropdownGetError: null,
            }
        case DrugsType.RECIPE_TYPE_DROPDOWN_SUCCESS:
            return {
                ...state,
                recipeTypeDropdownGetLoading: false,
                recipeTypeDropdownGetResponse: action.payload,
                recipeTypeDropdownGetError: null,
            }
        case DrugsType.RECIPE_TYPE_DROPDOWN_FAILURE:
            return {
                ...state,
                recipeTypeDropdownGetLoading: false,
                recipeTypeDropdownGetResponse: [],
                recipeTypeDropdownGetError: action.payload,
            }

        // Region DD dropdown api

        case DrugsType.REGION_DD_DROPDOWN_REQUEST:
            return {
                ...state,
                regionDropdownDDLoading: true,
                regionDropdownDDResponse: [],
                regionDropdownDDError: null,
            }
        case DrugsType.REGION_DD_DROPDOWN_SUCCESS:
            return {
                ...state,
                regionDropdownDDLoading: false,
                regionDropdownDDResponse: action.payload,
                regionDropdownDDError: null,
            }
        case DrugsType.REGION_DD_DROPDOWN_FAILURE:
            return {
                ...state,
                regionDropdownDDLoading: false,
                regionDropdownDDResponse: {},
                regionDropdownDDError: action.payload,
            }

        // Region DPC dropdown api
        case DrugsType.REGION_DPC_DROPDOWN_REQUEST:
            return {
                ...state,
                regionDropdownDPCLoading: true,
                regionDropdownDPCResponse: [],
                regionDropdownDPCError: null,
            }
        case DrugsType.REGION_DPC_DROPDOWN_SUCCESS:
            return {
                ...state,
                regionDropdownDPCLoading: false,
                regionDropdownDPCResponse: action.payload,
                regionDropdownDPCError: null,
            }
        case DrugsType.REGION_DPC_DROPDOWN_FAILURE:
            return {
                ...state,
                regionDropdownDPCLoading: false,
                regionDropdownDPCResponse: {},
                regionDropdownDPCError: action.payload,
            }

        // Pharameutical forms dropdown api

        case DrugsType.PHARMACEUTICAL_FORMS_DROPDOWN_REQUEST:
            return {
                ...state,
                pharameuticalFormsDropdownLoading: true,
                pharameuticalFormsDropdownResponse: [],
                pharameuticalFormsDropdownError: null,
            }
        case DrugsType.PHARMACEUTICAL_FORMS_DROPDOWN_SUCCESS:
            return {
                ...state,
                pharameuticalFormsDropdownLoading: false,
                pharameuticalFormsDropdownResponse: action.payload,
                pharameuticalFormsDropdownError: null,
            }
        case DrugsType.PHARMACEUTICAL_FORMS_DROPDOWN_FAILURE:
            return {
                ...state,
                pharameuticalFormsDropdownLoading: false,
                pharameuticalFormsDropdownResponse: {},
                pharameuticalFormsDropdownError: action.payload,
            }


        // Temperature dropdown api
        case DrugsType.TEMPERATURE_DROPDOWN_REQUEST:
            return {
                ...state,
                temperatureDropdowndLoading: true,
                temperatureDropdowndResponse: [],
                temperatureDropdowndError: null,
            }
        case DrugsType.TEMPERATURE_DROPDOWN_SUCCESS:
            return {
                ...state,
                temperatureDropdowndLoading: false,
                temperatureDropdowndResponse: action.payload,
                temperatureDropdowndError: null,
            }
        case DrugsType.TEMPERATURE_DROPDOWN_FAILURE:
            return {
                ...state,
                temperatureDropdowndLoading: false,
                temperatureDropdowndResponse: {},
                temperatureDropdowndError: action.payload,
            }
        default:
            return state;
    }
}

export default drugsReducer;